import { DistributedBars } from '../../Common/Charts/DistributedBars';
import { useProductionTemporalChartsDataContext } from './hooks/useProductionTemporalChartsDataContext';

const BASE_COLOR = '#0D82D3';
const CURRENT_YEAR_COLOR = '#4EAAEB';

export const ProductionTemporalEvolution = () => {
    const { chartData, filters } = useProductionTemporalChartsDataContext();

    const porAno = chartData?.temporalEvolution || {};
    const subtitles = Object.keys(porAno);
    const values = Object.values(porAno);
    const selectedYear = String(filters.year?.value || '');
    const colors = subtitles.map((year) =>
        year === selectedYear ? CURRENT_YEAR_COLOR : BASE_COLOR
    );

    return (
        <DistributedBars
            title={'Atendimentos por Ano'}
            values={values}
            subtitles={subtitles}
            colors={colors}
        />
    );
};
